import styled from "styled-components";
import { SortDirection } from "../Table.Parts";

// TEXT

// STYLES
export const Icon = styled.svg<SortIconProps>`
  height: 1.25rem;
  border-radius: 100%;
  transform: ${({ $sortDirection }) =>
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $sortDirection === SortDirection.DESCENDING && "rotate(180deg)"};
  transform-origin: center;
  flex-shrink: 0;
`;

// DATA

// TYPES
export type SortIconProps = {
  $sortDirection: SortDirection;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
